module.exports = __webpack_public_path__ + "static/media/highprecisionbc_sm.425cb508.jpg";